/**
 * Axios configuration for Dealer's Share My Inventory API
 * @module ShareMyInventoryAPI
 *
 * This is a private API of the dealerappcenter organization
 * The purpose is to retrieve vehicle's information like Vehicle Shares
 */

import axios from 'axios';

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_VEHICLE_API_URL}/v1`,
  params: {
    token: process.env.VUE_APP_TOKEN,
  },
});

export default instance;
